module.exports = __webpack_public_path__ + "static/media/1030006.48665d57.jpg";